var _effectorFileName = "/builds/gmini/front-sm-api-sdk/src/UserClassifierRepo/DynamicGroup/DynamicBaseGroup.ts";
import * as t from 'io-ts';
import { createPredicate } from '../../createPredicate';
import { Id } from '../../Id';
import { Version } from '../../Version';
import { DynamicGroup } from './DynamicGroup';
import { ElementProperty } from './ElementProperty';
export var DynamicBaseGroup;

(function (_DynamicBaseGroup) {
  var type = _DynamicBaseGroup.type = 'DynamicBaseGroup';
  var io = _DynamicBaseGroup.io = t.recursion('DynamicBaseGroup', function () {
    return t.type({
      type: t.literal(type),
      id: Id,
      sourceGroupId: Id,
      parentDynamicGroupId: t.union([t["null"], Id]),
      parentClassifierId: Id,
      parentClassifierVersion: Version,
      name: t.string,
      groupingConditions: t.array(ElementProperty.io)
    });
  });
  var is = _DynamicBaseGroup.is = createPredicate(type);
  var Populated;

  (function (_Populated) {
    var type = _Populated.type = 'DynamicBaseGroupPopulated';
    var io = _Populated.io = t.recursion('DynamicBaseGroupPopulated', function () {
      return t.type({
        type: t.literal(type),
        id: Id,
        sourceGroupId: Id,
        parentDynamicGroupId: t.union([t["null"], Id]),
        parentClassifierId: Id,
        parentClassifierVersion: Version,
        name: t.string,
        groupingConditions: t.array(ElementProperty.io),
        children: t.readonlyArray(DynamicGroup.io),
        offset: t.number,
        total: t.number
      });
    });
    var is = _Populated.is = createPredicate(type);
  })(Populated || (Populated = _DynamicBaseGroup.Populated || (_DynamicBaseGroup.Populated = {})));
})(DynamicBaseGroup || (DynamicBaseGroup = {}));